import { humanizeYearAndMonth } from './humanizeYearAndMonth';
export const DateAddedDivider = ({ children: dateAdded }) => {
  const prettyDateAdded = humanizeYearAndMonth(dateAdded);
  return (
    <div class='component__chords-list__divider'><hr data-content={prettyDateAdded}>{prettyDateAdded}</hr></div>
  );
}

